import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { RoutePickerComponent } from './route-picker.component';

@NgModule({
  declarations: [
    RoutePickerComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    RoutePickerComponent
  ]
})
export class RoutePickerModule { }
